import Heading from './Heading'
import Highlight from './Highlight'
import Paragraph from './Paragraph'
import Eyebrow from './Eyebrow'

// TODO: eventually map want to provide a custom mapper for folks to override
const componentMapper = ({ type, size } = {}) => {
  if (!type) {
    throw new Error('You must supply a type to Typestack component')
  }

  if (type === 'paragraph') {
    return {
      componentProp: 'p',
      Component: Paragraph
    }
  } else if (type === 'highlight') {
    return {
      componentProp: 'h1',
      Component: Highlight
    }
  } else if (type === 'heading') {
    if (size === 'xl') {
      return {
        componentProp: 'h2',
        Component: Heading
      }
    } else if (size === 'lg') {
      return {
        componentProp: 'h3',
        Component: Heading
      }
    } else if (size === 'md') {
      return {
        componentProp: 'h4',
        Component: Heading
      }
    } else if (size === 'sm') {
      return {
        componentProp: 'h5',
        Component: Heading
      }
    } else if (size === 'xs') {
      return {
        componentProp: 'h6',
        Component: Heading
      }
    } else {
      throw new Error(`Invalid size supplied to Typestack heading component (size: '${size}')`)
    }
  } else if (type === 'eyebrow') {
    return {
      componentProp: 'span',
      Component: Eyebrow
    }
  } else {
    throw new Error(`Invalid type supplied to Typestack component (type: '${type}')`)
  }
}

export default componentMapper
